export const DANA_ACTIVATED_DISCLAIMER_KEY = 'danaActivatedDisclaimer';
export const DANA_ACTIVATED_DISCLAIMER_BUTTON_BEHAVIOR_KEY =
    'danaActivatedDisclaimerButtonBehavior';

export const DANA_ACTIVATED_DISCLAIMER_BUTTON_BEHAVIOR = {
    ACTIVE: 'active',
    NOT_ACTIVE: 'notactive',
};

/**
 * Resolves button behavior with safe defaults when BE has not sent the new key yet.
 * - Accepted disclaimer → notactive (do not auto-prompt)
 * - Not accepted / missing → active (show disclaimer)
 */
export const resolveDanaDisclaimerButtonBehavior = (disclaimer, buttonBehavior) => {
    if (
        buttonBehavior === DANA_ACTIVATED_DISCLAIMER_BUTTON_BEHAVIOR.ACTIVE ||
        buttonBehavior === DANA_ACTIVATED_DISCLAIMER_BUTTON_BEHAVIOR.NOT_ACTIVE
    ) {
        return buttonBehavior;
    }

    return disclaimer
        ? DANA_ACTIVATED_DISCLAIMER_BUTTON_BEHAVIOR.NOT_ACTIVE
        : DANA_ACTIVATED_DISCLAIMER_BUTTON_BEHAVIOR.ACTIVE;
};

/**
 * Auto-prompt (e.g. CopilotBar on CRUD open) only when the user has not answered yet.
 * Intentional clicks may still show the ToS when disclaimer is false.
 */
export const shouldAutoPromptDanaDisclaimer = ({ disclaimer, buttonBehavior } = {}) => {
    if (disclaimer) return false;

    return (
        resolveDanaDisclaimerButtonBehavior(disclaimer, buttonBehavior) ===
        DANA_ACTIVATED_DISCLAIMER_BUTTON_BEHAVIOR.ACTIVE
    );
};
